// extracted by mini-css-extract-plugin
module.exports = {"stage":"Stage_stage__X6PLM","closeButton":"Stage_closeButton__ZGELs"};